if (!window.Eurus.loadedScript.has('scrolling-promotion.js')) {
  window.Eurus.loadedScript.add('scrolling-promotion.js');
  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xScrollPromotion', () => ({
        animationFrameId: null,
        window_height: 0,

        load(el) {
          this.window_height = window.xViewport.innerHeight;
          
          const container = el.getElementsByClassName('scrolling-container')[0];
          const item = container.getElementsByClassName('el_animate')[0];
          const frag = document.createDocumentFragment();

          for (let i = 0; i < 8; i++) {
            const clone = item.cloneNode(true);
            frag.appendChild(clone);
          }
          container.appendChild(frag);

          let scroll = el.getElementsByClassName('el_animate');
          for (let i = 0; i < scroll.length; i++) {
            scroll[i].classList.add('animate-scroll-banner');
          }
        },

        createObserver(el, rtlCheck = false) {
          const option = {
            root: null,
            rootMargin: '300px',
            threshold: 0
          };

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.updateRotation(el, rtlCheck)
              } else {
                if (this.animationFrameId) {
                  cancelAnimationFrame(this.animationFrameId);
                  this.animationFrameId = null;
                }
              }
            });
          }, option);

          observer.observe(el);
        },

        updateRotation(el, rtlCheck = false) {
          // PERF: getBoundingClientRect() her frame'de çağrıldığında zorunlu
          // layout tetikler (layout thrashing). Rect yalnızca scroll/resize
          // sonrası yeniden okunur; frame döngüsü sadece transform yazar.
          const element = el.firstElementChild;
          if (!element) return;

          let cachedTop = 0;
          let cachedHeight = 0;
          let rectDirty = true;
          let lastValue = null;

          const markDirty = () => { rectDirty = true; };
          window.addEventListener('scroll', markDirty, { passive: true });
          window.addEventListener('resize', markDirty, { passive: true });

          const update = () => {
            if (rectDirty) {
              const r = element.getBoundingClientRect();
              cachedTop = r.top;
              cachedHeight = r.height;
              rectDirty = false;
            }

            const element_height = cachedTop + cachedHeight / 2;
            let value;

            if (element_height > -200 && element_height < this.window_height + 200) {
              value = Math.max(Math.min((((element_height / this.window_height) * 10) - 5), 5), -5);
              if (rtlCheck) value *= -1;
              // Aynı değeri tekrar yazma — gereksiz stil hesaplamasını önler.
              if (value !== lastValue) {
                element.style.transform = `rotate(${value}deg) translateX(-20px)`;
                lastValue = value;
              }
            }

            this.animationFrameId = window.requestAnimationFrame(update);
          }

          if (!this.animationFrameId) {
            update();
          }
        },
      }));
    })
  });
}    